import React from "react";
import { AlertTriangle, CheckCircle2, UserX } from "lucide-react";
import { fmtNum } from "./balanceFields";

const MATCH_LABEL = { nome: "Nome", "nome parziale": "Nome parziale", matricola: "Matricola" };

const Changes = ({ changes }) => (
  changes.length === 0
    ? <span className="text-[12px] text-gray-400">Nessuna variazione</span>
    : <div className="flex flex-wrap gap-x-3 gap-y-1">
        {changes.map((c) => (
          <span key={c.field} className="text-[12px] whitespace-nowrap tabular-nums">
            <span className="text-gray-500">{c.label}:</span> <span className="text-gray-400">{fmtNum(c.before)}</span> → <b className={c.after < 0 ? "text-[#e30613]" : "text-[#16345c]"}>{fmtNum(c.after)}</b>
          </span>
        ))}
      </div>
);

const MatchedRow = ({ r, included, onToggle }) => (
  <tr className={`border-t border-gray-100 align-top ${included ? "" : "opacity-50"}`} data-testid={`import-row-${r.code}`}>
    <td className="px-3 py-2.5">
      <input type="checkbox" checked={included} onChange={() => onToggle(r.employee_id)} data-testid={`import-include-${r.code}`} className="w-4 h-4 accent-[#16345c] cursor-pointer" />
    </td>
    <td className="px-3 py-2.5"><div className="font-semibold text-gray-700">{r.pdf_name}</div><div className="text-[11px] text-gray-400">Cod. {r.code}</div></td>
    <td className="px-3 py-2.5">
      <div className="flex items-center gap-1.5 font-bold text-[#16345c]"><CheckCircle2 size={14} className="text-[#009640] shrink-0" /> {r.employee_name}</div>
      <div className="text-[11px] text-gray-400">per {MATCH_LABEL[r.match] || r.match}</div>
      {r.warning && <div className="flex items-center gap-1 text-[11px] text-amber-700 mt-0.5" data-testid={`import-warning-${r.code}`}><AlertTriangle size={12} /> {r.warning}</div>}
    </td>
    <td className="px-3 py-2.5"><Changes changes={r.changes} /></td>
  </tr>
);

export const ImportUnmatched = ({ rows }) => (
  rows.length === 0 ? null : (
    <div className="bg-red-50 border border-red-200 rounded-sm px-3 py-2.5 mt-3" data-testid="import-unmatched">
      <div className="flex items-center gap-1.5 text-[12.5px] font-bold text-red-700 mb-1"><UserX size={14} /> {rows.length} non trovati nel portale (verranno saltati)</div>
      <div className="text-[12px] text-red-700/90 leading-relaxed">
        {rows.map((r) => `${r.pdf_name} (cod. ${r.code})${r.match === "ambiguo" ? " — più corrispondenze" : ""}`).join(" · ")}
      </div>
    </div>
  )
);

export const ImportPreviewTable = ({ rows, excluded, onToggle }) => (
  <div className="border border-gray-200 rounded-sm overflow-auto max-h-[46vh]" data-testid="import-preview-table">
    <table className="w-full min-w-[760px] text-[12.5px]">
      <thead className="bg-gray-50 text-gray-500 text-[11px] uppercase sticky top-0 z-10">
        <tr><th className="w-10 px-3 py-2" /><th className="text-left px-3 py-2">Prospetto</th><th className="text-left px-3 py-2">Dipendente portale</th><th className="text-left px-3 py-2">Variazioni (prima → dopo)</th></tr>
      </thead>
      <tbody>
        {rows.map((r) => <MatchedRow key={r.code} r={r} included={!excluded.has(r.employee_id)} onToggle={onToggle} />)}
      </tbody>
    </table>
  </div>
);
